module.exports = __webpack_public_path__ + "img/use-template.0c6a9968.svg";